var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterParametersActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_182_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1242 0H1.71353C0.778875 0 0 0.60219 0 1.32482C0 2.04745 0.778875 2.64964 1.71353 2.64964H21.152C22.0867 2.64964 22.8656 2.04745 22.8656 1.32482C22.8377 0.60219 22.0867 0 21.1242 0Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1242 7.58594H1.71353C0.778875 7.58594 0 8.18813 0 8.91076C0 9.63338 0.778875 10.2356 1.71353 10.2356H21.152C22.0867 10.2356 22.8656 9.63338 22.8656 8.91076C22.8377 8.18813 22.0867 7.58594 21.1242 7.58594Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1242 15.1484H1.71353C0.778875 15.1484 0 15.7506 0 16.4733C0 17.1959 0.778875 17.7981 1.71353 17.7981H21.152C22.0867 17.7981 22.8656 17.1959 22.8656 16.4733C22.8377 15.7506 22.0867 15.1484 21.1242 15.1484Z",
    fill: "#FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_182_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterParametersActive);
export default __webpack_public_path__ + "static/media/footer-parameters-active.305fe8510537b6a8f834d714f162b5cf.svg";
export { ForwardRef as ReactComponent };